import { makeStyles } from '@material-ui/core'

const useMainRouterStyles = makeStyles((t) => ({
  container: {
    alignItems: 'flex-start',
  },
  content: {
    height: '100vh',
    width: '100vw',
    overflow: 'auto',
    overflowX: 'hidden',
    paddingTop: 'var(--top-bar-height)',
    transition: 'padding-top 250ms linear',
    '& > *': {
      backgroundColor: '#F4F6FF', // Cor de fundo sólida para oken
      backgroundSize: '100vw 288vw',
      backgroundPosition: '0px -1452px',
      backgroundImage: 'none', // Remove completamente a imagem de background
      position: 'relative',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    '&:last-child': {
      animationDelay: '-100ms',
      pointerEvents: 'none',
    },
    '&:first-child': {
      pointerEvents: 'initial',
    },
  },
  noSpacing: {
    paddingTop: '0px',
  },
  transitionRoot: {
    minHeight: 'initial',
  },
}))

export default useMainRouterStyles

